import { FC, useState } from "react";
import { IProps } from "./core/modalConfigPickRestaurant.types";
import { IConfigurationState } from "redux/configuration/configuration.interface";
import { Trans, useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import SelectStorePopup from "pages/InformationForm/StoreSelectPopup";
import Button from "components/Inputs/Button";
import { Icons } from "utils/constants/icons";

const ModalConfigPickRestaurant: FC<IProps> = ({
  hideModal,
  establishments,
  onRestaurantSelected,
}) => {
  const [selectedId, setSelectedId] = useState<number>();
  const { configuration } = useSelector((state: IConfigurationState) => state);
  const { t } = useTranslation("modals");

  const onStoreSelected = (store: string) => {
    const establishmentIndex = establishments.findIndex((etablishment) => {
      return etablishment?.cid === store;
    });
    setSelectedId(establishmentIndex);
  };

  return (
    <div className="f f-direction-column">
      <div className="mt-4 modal__img">
        <img src="/static/images/modals/pin.png" alt="smile emoji" />
      </div>
      <div className="p-3 align-text-center f-jc-space-b f-ai-center pb-3 ft-center ">
        <h2>
          <Trans
            ns="modals"
            i18nKey="restaurant.title"
            components={[<span className=" ft-cap-first c-primary"></span>]}
          />
        </h2>
        <div className="mt-3">
          <span className="t-2">
            <Trans
              ns="modals"
              i18nKey="restaurant.subtitle"
              components={[<span className=" ft-cap-first c-primary"></span>]}
              values={{ restaurant: configuration?.dn }}
            />
          </span>
        </div>
      </div>
      <div className=" mx-4 ">
        <SelectStorePopup
          storeList={establishments}
          setSelectedStore={onStoreSelected}
        />
      </div>
      <div className=" px-4 flex w-full items-center justify-center">
        <Button
          icon={Icons.chevronRight}
          disabled={selectedId === undefined}
          appearance="primary"
          text={t("restaurant.CTA")}
          onClick={() => {
            onRestaurantSelected(selectedId);
            hideModal();
          }}
          className="w-full"
        />
      </div>
    </div>
  );
};

export default ModalConfigPickRestaurant;
